<!--
* @description  参数1
* @fileName  contactDetails
* @author userName
* @date 2024-01-25 16:25:19
!-->
<template>
  <div id="contactDetails" class="contactDetails">
    <div class="contact-title">
      <div class="contact-title-one">{{ activeName }}</div>
      <!--      <div v-if="true" class="contact-title-two">The exporter of record for your shipment. Usually the factory,
        sourcing agent, etc.</div> -->
    </div>
    <div class="contact-details">
      <div class="c-d-title">
        <div class="c-d-title-l">{{ data.companyName }}</div>
        <div class="c-d-title-r" @click="clickEdit">修改</div>
      </div>
      <div class="font400 gary">{{ data.name }}</div>
      <div class="font400 marg10">
        <div class="gary">{{ data.email }}</div>
        <div class="gary">{{ data.tel }}</div>
        <div class="gary">{{ data.cityName }},{{ data.provinceName }},{{ data.zipCode }},{{ data.countryNameEn }}
        </div>
      </div>
      <div class="font-blue" @click="changeAddress">更换地址</div>
      <!--      <div class="pickup">
        <div v-if="isDelivery" class="confirm-box">
          <div class="confirm-tip">
            <i class="el-icon-question" />
            <span>Are you sure your consignee’s contact details are different from delivery?</span>
          </div>
          <div class="confirm-foot">
            <span @click="confirmDelivery(0)">NO</span>
            <button class="by-button--primary save" @click="confirmDelivery(1)">Yes</button>
          </div>
          <div class="message_jiantou" />
        </div>
        <div class="pickup-checked">
          <el-switch
            v-model="isPickup"
            active-color="#13ce66"
            inactive-color="#777777"
            active-text="Consignor contact has  the same contact details as pickup"
            @click.native="bulletinSwitch()"
          />
        </div>
        <ByTip
          :prompt="`Consignor contact details are the same as pickup. To edit, go to pickup.`"
          :width="964"
          :height="40"
          :color="`#E95506`"
          :background="`rgba(233,85,6,0.04)`"
          :text-align="'left'"
        />
      </div>
    </div> -->

    </div>
  </div></template>

<script>
import {
  GetOrderAddress
} from '../../../../../../../api/order.js'
import ByTip from '../../../../../../../components/byTip/byTip.vue'

export default {
  name: 'ContactDetails',
  components: {
    // 组件的引用
    ByTip
  },
  props: {
    // 父辈向子辈传参
    activeName: {
      type: String,
      default: () => {
        return ''
      }
    }

  },
  data() {
    return {
      isPickup: false,
      isDelivery: false,
      orderData: {},
      addrType: undefined,
      data: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data, addrType) {
      this.orderData = data
      this.addrType = addrType
      GetOrderAddress({
        addrType: this.addrType,
        orderNo: data.orderNo
      }).then(res => {
        if (res.code === 200) {
          this.data = res.data
        }
      })
    },
    // 方法
    bulletinSwitch() {
      this.isPickup = !this.isPickup
      this.isDelivery = true
    },
    confirmDelivery(val) {
      this.isPickup = val == 1
      this.isDelivery = false
    },
    changeAddress() {
      this.$emit('isSelect')
      document.getElementsByClassName('confirmOrder')[0].style.top = '0'
      document.getElementsByClassName('confirmOrder')[0].style.overflow = 'visible'
    },
    clickEdit() {
      this.$emit('isEdit', this.data)
    }
  }
}
</script>
<style scoped lang='scss'>
	.font400 {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;

	}

	.contactDetails {
		width: 996px;

		.contact-title {
			background: #FFFFFF;
			text-align: left;
			padding: 15px 0 13px 0;
			margin-bottom: 20px;
			border-radius: 8px;
			padding: 17px 16px;

			.contact-title-one {
				font-size: 18px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				color: #333333;
			}

			.contact-title-two {
				@extend .font400;
				margin-top: 11px;
				color: #333333;
			}
		}

		.contact-details {
			background: #FFFFFF;
			margin-top: 16px;
			border-radius: 8px;
			padding: 16px;
			text-align: left;

			.c-d-title {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.c-d-title-l {
					font-size: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 550;
					color: #333333;
				}

				.c-d-title-r {
					font-size: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #EF0A0A;
					cursor: pointer;
				}
			}

			.gary {
				color: #777777;
				height: 28px;
				line-height: 26px;
			}

			.marg10 {
				margin: 10px 0
			}

			.font-blue {
				cursor: pointer;
				@extend .font400;
				color: #027FFC;
				height: 28px;
				line-height: 26px;
			}

			.pickup {
				margin-top: 8px;
				height: 70px;
				border-top: 1px dashed #DDDDDD;
				padding-top: 16px;
				position: relative;

				.pickup-checked {
					display: flex;
					align-items: center;
					height: 32px;
					margin-bottom: 8px;

					::v-deep .el-switch__label,
					.is-active {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
					}
				}

				//确认框样式
				.confirm-box {
					width: 304px;
					height: 111px;
					background: #FFFFFF;
					box-shadow: 0px 2px 18px 0px rgba(128, 0, 0, 0.08);
					border: 1px solid rgba(221, 221, 221, 0.4);
					position: absolute;
					bottom: 80px;

					.confirm-tip {
						margin: 16px;
						display: flex;

						i {
							margin-right: 8px;
							color: #E95506;
						}

						span {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #333333;
						}
					}

					.confirm-foot {
						margin: 16px;
						display: flex;
						align-items: center;
						justify-content: end;

						span {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #EF0A0A;
						}

						button {
							width: 56px;
							height: 28px;
							margin-left: 24px;
						}
					}

					.message_jiantou {
						position: absolute;
						border-top: solid 10px #fff;
						border-left: solid 10px transparent;
						border-right: solid 10px transparent;
						left: 3%;
						top: 111px;
						// box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);

					}
				}
			}
		}
	}
</style>
